<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Card number</h3>
  </div>

  <!---------- main content ---------->

  <div class="dialog-content__container">
    <form [formGroup]="cardForm">
      <div class="mb-16 flex_container">
        <label>Card number</label>
        <div class="col-sm-3">
          <input
            type="text"
            class="input__basic"
            placeholder=" "
            formControlName="cardNumber"
          />
        </div>
      </div>
      <div class="mt-16 flex_container">
        <label>Card's end date</label>
        <app-datepicker
          [iconLeft]="true"
          formControlName="endDate"
          [staticPropery]="true"
        >
        </app-datepicker>
      </div>
    </form>
  </div>

  <!--  save/cancel buttons -->
  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="close()">Cancel</button>
    </div>
  </div>

  <img
    class="interview__trash icon"
    src="assets/icons/svg/trash/ion_trash-bin.svg"
    alt="trash"
    *ngIf="!isCreate"
    (click)="deleteCard()"
  />
</div>
